// extracted by mini-css-extract-plugin
export var container = "HeaderFeedCell-module--container--ZhPiD";
export var cardContents = "HeaderFeedCell-module--cardContents--JMXnz";
export var link = "HeaderFeedCell-module--link--1euvK";
export var footer = "HeaderFeedCell-module--footer--226c5";
export var cardTitle = "HeaderFeedCell-module--cardTitle--KVLLs";
export var cardFooter = "HeaderFeedCell-module--cardFooter--KqvkW";